import React, { useState } from 'react';
import { SayanAxiosInstance } from '../../Network/SayanAxiosInstance';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Joi from 'joi';
import { Select, MenuItem, FormControl } from '@mui/material';

const ConnectToSayan: React.FC = () => {
  const [claimID,setclaimID] = useState<string>('');
  const [patientdob,setpatientdob] = useState<string>('');
  const [patientGender,setpatientGender] = useState<string>("M");
  const [encounterType,setencounterType] = useState<string>('');

  const [primaryDiagnosisCode,setprimaryDiagnosisCode] = useState<string>('');
  const [seconderyDiagnosisCodes,setseconderyDiagnosisCodes] = useState<string>('');
  const [serviceType,setServicetype] = useState<string>('procedure');
  const [serviceCode,setserviceCode] = useState<string>('');
  const [serviceQuantity,setserviceQuantity] = useState<string>('');
  const [errorMessages, setErrorMessages] = useState([]);
  const [claimIDError, setClaimIDError] = useState<string>("");
  const [encounterTypeError, setencounterTypeError] = useState<string>('');
  const [serviceQuantityError, setserviceQuantityError] = useState<string>('');
  const [serviceCodeError, setServiceCodeError] = useState<string>('');


  const ClaimIDschema = Joi.string().allow("")
  .regex(/^\d+$/)
  .messages({
    "string.pattern.base": "Please enter only numbers",
  });

  const encounterTypeschema = Joi.string().regex(/^\d+$/).messages({
    'string.pattern.base': 'Please enter only numbers',
  });

  const serviceQuantityschema = Joi.string().regex(/^\d+$/).messages({
    'string.pattern.base': 'Please enter only numbers',
  });

  const serviceCodeSchema = Joi.string().regex(/^[\d\-]+$/).messages({
    'string.pattern.base': 'Please enter only numbers connected by a (-) sign, such as (36552-01-02).',
  });

  const handleClaimIDChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
  
  // check the entry using Joi
    const { error } = ClaimIDschema.validate(value);
  
    if (error) {
      setClaimIDError(error.message); 
    } else {
      setClaimIDError(""); 
      setclaimID(e.target.value);  }
  };
  
  // handleEncounterTypeChange
  const handleEncounterTypeChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
  
    const { error } = encounterTypeschema.validate(value);
  
    if (error) {
      setencounterTypeError(error.message);
    } else {
      setencounterTypeError("");
      setencounterType(e.target.value);  }
  };
  // handleServiceCodeChange
  const handleServiceCodeChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
  
    const { error } = serviceCodeSchema.validate(value);
  
    if (error) {
      setServiceCodeError(error.message); 
    } else {
      setServiceCodeError(''); 
      setserviceCode(e.target.value);
    }
  };
  // handleserviceQuantityChange
  const handleserviceQuantityChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
  
    const { error } = serviceQuantityschema.validate(value);
  
    if (error) {
      setserviceQuantityError(error.message); 
    } else {
      setserviceQuantityError(''); 
      setserviceQuantity(e.target.value);
    }
  };
  
  

  const addItem = async (): Promise<void> => {
    try {
      const newConnect = { "data":[{ claim_ID:claimID, patient_dob:patientdob,patient_gender:patientGender, 
        encounter_type:encounterType,primary_diagnosis_code:primaryDiagnosisCode,secondery_diagnosis_codes:seconderyDiagnosisCodes
        ,service_type:serviceType,service_code:serviceCode,service_quantity:serviceQuantity}]};
     const reaponse=  await SayanAxiosInstance.post('validation',  newConnect);
     
    setclaimID('')
   setpatientdob('');
   setpatientGender('M');
   setencounterType('');
   setprimaryDiagnosisCode('');
   setseconderyDiagnosisCodes('');
   setServicetype('procedure');
   setserviceCode('');
   setserviceQuantity('');
  
   setErrorMessages(reaponse.data.validationErrors.map((error: any) => error.Message))
  
  console.log('NewConnect Added Successfully:', newConnect);
  if (reaponse.data.validationErrors && reaponse.data.validationErrors.length > 0) {
    reaponse.data.validationErrors.forEach((error: any) => {
      toast.error(error.Message);
    });
  }
  }   catch (error: any) {
    console.error('Error adding item:', error);
    
  // If there is an error in the server's response
    if (error.response && error.response.data && error.response.data.validationErrors) {
      error.response.data.validationErrors.forEach((validationError: any) => {
        toast.error(validationError.Message);
      });
    } else if (error.message) {
      toast.error(`Error: ${error.message}`);
    } else {
      toast.error('An unexpected error occurred');
    }
    }
  
  };

  return (
    <div className='container' style={{ margin: '30px' }}>
      <h5>ConnectToSayan Screen <span><i className="fa-solid fa-briefcase"></i></span></h5>
      <div className='row p-3  shadow-lg' style={{marginTop:"40px"}}>
    <div className="col-md-6 d-flex flex-column  align-items-center  "> 


   <button
    id="add_button"
   className="btn btn-success" data-bs-toggle="modal" data-bs-target="#exampleModal">
            Add New 
          </button>
          
             </div>
   

   
</div>

{/*Model*/}

      <div className='modal fade' id='exampleModal' aria-labelledby='exampleModalLabel' aria-hidden='true'>
        <div className='modal-dialog'>
          <div className='modal-content' style={{ width: "130%"}}>
            <div className='modal-header'>
              <h5 className='modal-title' id='exampleModalLabel'>Add Item</h5>
              <button type='button' className='btn-close' data-bs-dismiss='modal' aria-label='Close'></button>
            </div>

            <div className='container'>
              <div className='row'  style={{ height:"45vh"}} >
                {/* First row */}
                <div className='col-md-4'>
                  <label>Claim ID:</label>
                  <input type='text' className={`form-control ${claimIDError ? 'is-invalid' : ''}`} value={claimID === "" ? 0: parseInt(claimID)} onChange={handleClaimIDChange} />
                  {claimIDError && <div style={{ color: 'red' }}>{claimIDError}</div>}
                </div>
                <div className='col-md-4'>
                  <label>Patient DOB:</label>
                  <input type='date' className='form-control' value={patientdob} onChange={(e) => setpatientdob(e.target.value)} min="1940-01-01" max={new Date().toISOString().split("T")[0]} />
                </div>
                <div className='col-md-4'>
                  <label>Gender:</label>
                  <div>
                    Male: <input type='radio' name='gender' value='M' checked={patientGender === 'M'} onChange={() => setpatientGender('M')} style={{ marginRight: '10px' }} />
                    Female: <input type='radio' name='gender' value='F' checked={patientGender === 'F'} onChange={() => setpatientGender('F')} />
                  </div>
                </div>

                {/* Second row */}
                <div className='col-md-4'>
                  <label>Encounter Type:</label>
                  <select
                    className={`form-control ${encounterTypeError ? 'is-invalid' : ''}`}
                    value={encounterType}
                    onChange={(e) => {
                      setencounterTypeError("");
                      setencounterType(e.target.value);
                    }}
                  >
                    <option value="">Select Encounter Type</option>
                    <option value="1">1 - No Bed + No emergency room (outpatient).</option>
                    <option value="2">2 - No Bed + Emergency room (outpatient).</option>
                    <option value="3">3 - Inpatient Bed + No emergency room</option>
                    <option value="4">4 - Inpatient Bed + Emergency room.</option>
                    <option value="5">5 - Daycase Bed + No emergency room.</option>
                    <option value="6">6 - Daycase Bed + Emergency room.</option>
                    <option value="7">7 - Nationals Screening</option>
                    <option value="8">8 - New Visa Screening.</option>
                    <option value="9">9 - Renewal Visa Screening</option>
                    <option value="12">12 - Home</option>
                    <option value="13">13 - Assisted Living Facility</option>
                    <option value="15">15 - Mobile Unit.</option>
                    <option value="41">41 - Ambulance Land.</option>
                    <option value="42">42 - Ambulance Air or Water</option>
                  </select>
                  {encounterTypeError && <div style={{ color: 'red' }}>{encounterTypeError}</div>}
                </div>
                <div className='col-md-4'>
                  <label>Primary Diagnosis Code:</label>
                  <input type='text' className='form-control' value={primaryDiagnosisCode} onChange={(e) => setprimaryDiagnosisCode(e.target.value)} />
                </div>
                <div className='col-md-4'>
                  <label>Secondary Diagnosis Codes:</label>
                  <input type='text' className='form-control' value={seconderyDiagnosisCodes} onChange={(e) => setseconderyDiagnosisCodes(e.target.value)} />
                </div>

                {/* Third row */}
                <div className='col-md-4'>
                 
                  <label>Service Type:</label>
                  <FormControl style={{ width: '188px' }}>
                    <Select value={serviceType} onChange={(e) => setServicetype(e.target.value)}>
                      <MenuItem value='procedure'>Procedure</MenuItem>
                      <MenuItem value='service'>Service</MenuItem>
                      <MenuItem value='dental'>Dental</MenuItem>
                      <MenuItem value='GMDN'>GMDN</MenuItem>
                    </Select>
                  </FormControl>
                  
                </div>
                <div className='col-md-4'>
                  <label>Service Code:</label>
                  <input type='text' className={`form-control ${serviceCodeError ? 'is-invalid' : ''}`} value={serviceCode} onChange={handleServiceCodeChange} />
                  {serviceCodeError && <div style={{ color: 'red' }}>{serviceCodeError}</div>}
                </div>
                <div className='col-md-4'>
                  <label>Service Quantity:</label>
                  <input type='text' className={`form-control ${serviceQuantityError ? 'is-invalid' : ''}`} value={serviceQuantity} onChange={handleserviceQuantityChange} />
                  {serviceQuantityError && <div style={{ color: 'red' }}>{serviceQuantityError}</div>}
                </div>
              </div>
            </div>

            <div className='modal-footer'>
              <button type='button' className='btn btn-secondary' data-bs-dismiss='modal'>Close</button>
              <button type='button' className='btn btn-primary' onClick={addItem}>Add</button>
            </div>
          </div>
        </div>
      </div>

      <ToastContainer />
    </div>
  );
};

export default ConnectToSayan;
